import { useUserStore } from '@/store/useUserStore'

export const useGetWalletDataByCryptoCode = ({
  cryptoCode,
}: {
  cryptoCode?: string
}) => {
  const completeCurrencies = useUserStore(
    (state) => state.wallet?.completeCurrencies,
  )

  const walletData = completeCurrencies?.find(
    (item) => item.code === cryptoCode,
  )

  return walletData
}
